import React, { useState } from "react";

import axios from "axios";
import Swal from "sweetalert2";
import BASE_URL from "../config";

const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    full_name: "",
    phone_number: "",
    message: "",
  });

  const [validationErrors, setValidationErrors] = useState({});

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });

    // Clear validation error for the specific field
    setValidationErrors((prevErrors) => {
      const { [id]: removedError, ...remainingErrors } = prevErrors;
      return remainingErrors;
    });
  };

  const handleFocus = (fieldId) => {
    setValidationErrors((prevErrors) => {
      const { [fieldId]: removedError, ...remainingErrors } = prevErrors;
      return remainingErrors;
    });
  };

  const validateForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regular expression for email validation
    const phoneRegex = /^[0-9+()]+$/; // Regular expression for phone number validation

    if (!formData.email.trim()) {
      errors.email = "Email is required.";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Invalid email format.";
    }

    if (!formData.full_name.trim()) {
      errors.full_name = "Full Name is required.";
    }

    if (!formData.phone_number.trim()) {
      errors.phone_number = "Phone Number is required.";
    } else if (!phoneRegex.test(formData.phone_number)) {
      errors.phone_number = "Phone Number can only contain numbers.";
    }

    if (!formData.message.trim()) {
      errors.message = "Message is required.";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // Build your HTML table string
      const htmlTable = `
      <table border="1" cellpadding="10" cellspacing="0" style="border-collapse: collapse; font-family: Arial, sans-serif; width: 100%;">
        <tr style="background-color: #f2f2f2;">
          <th align="left">Email</th>
          <td>${formData.email}</td>
        </tr>
        <tr>
          <th align="left">Full Name</th>
          <td>${formData.full_name}</td>
        </tr>
        <tr style="background-color: #f2f2f2;">
          <th align="left">Phone Number</th>
          <td>${formData.phone_number}</td>
        </tr>
        <tr>
          <th align="left">Message</th>
          <td>${formData.message}</td>
        </tr>
      </table>
    `;

      try {
        setLoading(true);
        await axios.post(`${BASE_URL}api/email/contactus`, {
          bodyText: htmlTable,
        });

        Swal.fire({
          icon: "success",
          title: "Message Sent",
          text: "Your message has been sent successfully!",
        });

        // Reset form
        setFormData({
          email: "",
          full_name: "",
          phone_number: "",
          message: "",
        });
        setValidationErrors({});
      } catch (error) {
        console.error("Error sending message:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "There was an error sending your message. Please try again.",
        });
      }
      finally {
      setLoading(false);
    }
    }
  };
  return (
    <form className="contact-contact-form" onSubmit={handleSubmit}>
      <div className="contact-contact-field">
        <input
          type="text"
          id="email"
          className="contact-input"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleInputChange}
          onFocus={() => handleFocus("email")}
        />
        {validationErrors.email && (
          <small
            className="text-danger"
            style={{ display: "block", textAlign: "start" }}
          >
            {validationErrors.email}
          </small>
        )}
      </div>
      <div className="contact-contact-inline-fields">
        <div className="contact-contact-field">
          <input
            type="text"
            id="full_name"
            className="contact-input"
            name="full_name"
            placeholder="Full Name"
            value={formData.full_name}
            onChange={handleInputChange}
            onFocus={() => handleFocus("full_name")}
          />
          {validationErrors.full_name && (
            <small
              className="text-danger"
              style={{ display: "block", textAlign: "start" }}
            >
              {validationErrors.full_name}
            </small>
          )}
        </div>
        <div className="contact-contact-field">
          <input
            type="text"
            id="phone_number"
            className="contact-input"
            name="phone_number"
            placeholder="Phone Number"
            value={formData.phone_number}
            onChange={handleInputChange}
            onFocus={() => handleFocus("phone_number")}
          />
          {validationErrors.phone_number && (
            <small
              className="text-danger"
              style={{ display: "block", textAlign: "start" }}
            >
              {validationErrors.phone_number}
            </small>
          )}
        </div>
      </div>
      <div className="contact-contact-field">
        <textarea
          id="message"
          className="contact-textarea"
          name="message"
          placeholder="Message"
          value={formData.message}
          onChange={handleInputChange}
          onFocus={() => handleFocus("message")}
        ></textarea>
        {validationErrors.message && (
          <small
            className="text-danger"
            style={{ display: "block", textAlign: "start" }}
          >
            {validationErrors.message}
          </small>
        )}
      </div>
      <div className="contact-contact-bottom-container">
     <button
  type="submit"
  className="contact-button-form"
  disabled={loading}
  style={{
    cursor: loading ? "not-allowed" : "pointer",
    opacity: loading ? 0.7 : 1,
  }}
>
  {loading ? (
    <>
      <span
        className="spinner"
        style={{
          display: "inline-block",
          width: "16px",
          height: "16px",
          border: "2px solid #fff",
          borderTop: "2px solid transparent",
          borderRadius: "50%",
          marginRight: "8px",
          animation: "spin 1s linear infinite",
          verticalAlign: "middle",
        }}
      ></span>
      Sending...
    </>
  ) : (
    "Send Message"
  )}
</button>

      </div>
    </form>
  );
};

export default ContactForm;
